/** Antippbarer Begriff mit kurzer Erklärung (content/glossary.ts). */
import { useEffect, useRef, useState, type ReactNode } from 'react';
import { createPortal } from 'react-dom';
import { GLOSSARY } from '../content/glossary';

export function Term({ id, children }: { id: string; children?: ReactNode }) {
  const G = GLOSSARY[id]; const [pos, setPos] = useState<{ x: number; y: number; up: boolean } | null>(null);
  const ref = useRef<HTMLButtonElement>(null), tip = useRef<HTMLDivElement>(null);
  useEffect(() => {
    if (!pos) return;
    const close = (e: Event) => { if (e.type === 'keydown' && (e as KeyboardEvent).key !== 'Escape') return; if (e.type === 'pointerdown' && (tip.current?.contains(e.target as Node) || ref.current?.contains(e.target as Node))) return; setPos(null); };
    addEventListener('pointerdown', close); addEventListener('keydown', close); addEventListener('scroll', close, true); addEventListener('resize', close);
    return () => { removeEventListener('pointerdown', close); removeEventListener('keydown', close); removeEventListener('scroll', close, true); removeEventListener('resize', close); };
  }, [pos]);
  if (!G) return <>{children}</>;
  const open = () => { const r = ref.current!.getBoundingClientRect(), w = Math.min(340, innerWidth - 24); const up = r.bottom + 200 > innerHeight && r.top > 220; setPos({ x: Math.max(12, Math.min(r.left, innerWidth - w - 12)), y: up ? innerHeight - r.top + 8 : r.bottom + 8, up }); };
  return (
    <>
      <button type="button" ref={ref} className="term" aria-expanded={!!pos} onClick={(e) => { e.stopPropagation(); if (pos) setPos(null); else open(); }}>{children ?? G.t}</button>
      {pos && createPortal(<div ref={tip} className="termtip" role="tooltip" style={{ left: pos.x, ...(pos.up ? { bottom: pos.y } : { top: pos.y }) }}><b>{G.t}</b>{G.d}</div>, document.body)}
    </>
  );
}
